import { render, staticRenderFns } from "./BookSuiteForm.vue?vue&type=template&id=b2a50424&scoped=true&"
import script from "./BookSuiteForm.vue?vue&type=script&lang=js&"
export * from "./BookSuiteForm.vue?vue&type=script&lang=js&"
import style0 from "./BookSuiteForm.vue?vue&type=style&index=0&id=b2a50424&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2a50424",
  null
  
)

export default component.exports